import { render, staticRenderFns } from "./CardResponse.vue?vue&type=template&id=5cbc7afe&scoped=true&"
import script from "./CardResponse.vue?vue&type=script&lang=js&"
export * from "./CardResponse.vue?vue&type=script&lang=js&"
import style0 from "./CardResponse.vue?vue&type=style&index=0&id=5cbc7afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc7afe",
  null
  
)

export default component.exports